import { SxProps, Theme } from '@mui/material'
import {
  AISLE_HEADER_BG,
  BORDER_SUBTLE,
  GRID_COL_HEADER_BG,
  GRID_COL_HEADER_BORDER,
  SURFACE_MUTED,
  WHITE,
} from '../config/constants'

/** Estilos de la vista frontal de pasillo. Lo compartido vive en `shared.styles`. */
export const aisleDetailStyles = {
  paper: {
    maxHeight: '92vh',
    display: 'flex',
    flexDirection: 'column',
  } as SxProps<Theme>,

  header: {
    bgcolor: AISLE_HEADER_BG,
    color: WHITE,
    py: 1,
    px: 2,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexShrink: 0,
  } as SxProps<Theme>,

  headerTitle: { fontSize: '1rem' } as SxProps<Theme>,

  closeButton: { color: WHITE } as SxProps<Theme>,

  /** Barra de controles: mismo estilo que la banda de modo de la grilla principal. */
  controlsBar: {
    px: 2,
    py: 0.75,
    borderBottom: `1px solid ${BORDER_SUBTLE}`,
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    flexShrink: 0,
  } as SxProps<Theme>,

  modeLabel: {
    textTransform: 'uppercase',
    letterSpacing: 0.5,
    mr: 0.5,
  } as SxProps<Theme>,

  modeButton: (isActive: boolean): SxProps<Theme> => ({
    textTransform: 'none',
    minWidth: 88,
    fontWeight: isActive ? 700 : 400,
  }),

  legendBar: {
    px: 2,
    py: 0.75,
    borderBottom: `1px solid ${BORDER_SUBTLE}`,
    bgcolor: SURFACE_MUTED,
    display: 'flex',
    flexWrap: 'wrap',
    gap: 1.5,
    alignItems: 'center',
    flexShrink: 0,
  } as SxProps<Theme>,

  content: {
    p: 0,
    overflow: 'hidden',
    display: 'flex',
    flex: 1,
  } as SxProps<Theme>,

  loadingWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
  } as SxProps<Theme>,

  errorText: { p: 2 } as SxProps<Theme>,

  body: {
    display: 'flex',
    width: '100%',
    overflow: 'hidden',
  } as SxProps<Theme>,

  /** Padding derecho e inferior: deja aire para que la última celda no toque el borde. */
  scrollArea: {
    overflow: 'auto',
    flex: 1,
    pr: 1.5,
    pb: 1.5,
  } as SxProps<Theme>,

  grid: (templateColumns: string): SxProps<Theme> => ({
    display: 'inline-grid',
    gridTemplateColumns: templateColumns,
    gap: '3px',
    minWidth: 'max-content',
  }),

  headerCellText: { userSelect: 'none' } as SxProps<Theme>,

  /**
   * Chip de nivel con estilo de encabezado, no de botón: a diferencia del chip
   * de pasillo de la grilla, el nivel no es clickeable. El azul relleno se
   * reserva para lo que sí responde al click.
   */
  levelChip: (size: number): SxProps<Theme> => ({
    position: 'sticky',
    left: 0,
    zIndex: 10,
    bgcolor: GRID_COL_HEADER_BG,
    border: `1px solid ${GRID_COL_HEADER_BORDER}`,
    borderRadius: '2px',
    height: size,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'default',
  }),

  levelChipText: {
    whiteSpace: 'nowrap',
    userSelect: 'none',
  } as SxProps<Theme>,
}
